import React, { useState, useEffect } from 'react';
import './index.scss';
import MultiSelectManage from '../../../components/multiSelectManage/multiSelectManage';
import { apiHolder as api, apis } from 'api';
const templateApi = api.api.requireLogicalApi(apis.mailTemplateImplApi);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const ManageGroup = ({ visible, closeModal }) => {
    const [tagList, setTagList] = useState([]);
    const [editId, setEditId] = useState();
    const [editName, setEditName] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const editTag = (tag) => {
        if (editId) {
            return;
        }
        setEditId(tag.tagId);
        setEditName(tag.tagName);
    };
    const deleteTag = async (tag) => {
        const res = await templateApi.deleteTemplateTags({ tagIdList: [tag.tagId] });
        if (res.success) {
            setErrMsg('');
            setTagList(tagList.filter(item => {
                return item.tagId !== tag.tagId;
            }) || []);
            trackApi.track('pc_markting_edm_template_newgroup_operation', {
                operation: 'delete',
            });
            return;
        }
        setErrMsg(res.message || '');
    };
    const onCancel = () => {
        setEditId(undefined);
        setEditName('');
        setErrMsg('');
    };
    const onSave = async (tag) => {
        const res = await templateApi.saveOrUpdateTemplateTag({ tagId: tag.tagId, tagName: editName, templateCategory: 'LX-WAIMAO' });
        if (res.success) {
            setErrMsg('');
            onCancel();
            getTemplateTagList();
            trackApi.track('pc_markting_edm_template_newgroup_operation', {
                operation: 'edit',
            });
            return;
        }
        setErrMsg(res.message || '');
    };
    const getTemplateTagList = async () => {
        var _a;
        const res = await templateApi.getTemplateTagList({ templateType: 'PERSONAL' });
        if (res.success) {
            setTagList(((_a = res.data) === null || _a === void 0 ? void 0 : _a.tagList) || []);
            return;
        }
        setTagList([]);
    };
    const onNameChange = (event) => {
        setEditName(event.target.value || '');
    };
    useEffect(() => {
        visible && getTemplateTagList();
    }, [visible]);
    return (React.createElement(MultiSelectManage, { visible: visible, editId: editId, editName: editName, dataList: tagList.map(item => (Object.assign(Object.assign({}, item), { id: item.tagId, name: item.tagName }))), editItem: editTag, saveItem: onSave, deleteItem: deleteTag, closeModal: closeModal, onNameChange: onNameChange, onCancel: onCancel, errorMessage: errMsg }));
};
export default ManageGroup;
